// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/ru-RU'
import VueResource from 'vue-resource'
import * as VueGoogleMaps from 'vue2-google-maps'
import Inputmask from 'inputmask'
import store from './components/store/index'
import VueTruncate from 'vue-truncate-filter'
import VueRouter from 'vue-router'
import VueMask from 'v-mask'
import './scss/main.scss'

Vue.use(VueMask)
Vue.config.productionTip = false
Vue.use(Element, {locale})
Vue.use(VueResource)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAMDkU58_HT14hF-Nq8VhwlvhKKFOGgLs8',
    libraries: 'places,drawing,visualization'
  }
})

Vue.directive('input-mask', {
  bind: function (el) {
    new Inputmask().mask(el)
  }
})

Vue.use(VueTruncate)
Vue.use(VueRouter)

import App from './App'

const vueConfigName = 'vueConfig'

do {
  if (!window[vueConfigName] || !window[vueConfigName].applications) {
    break
  }
  const applicationList = window[vueConfigName].applications

  if (!Array.isArray(applicationList)) {
    break
  }
  applicationList.forEach(function (application) {
    if (!application.element) {
      return
    }
    if (!application.name) {
      return
    }
    if (document.getElementById(application.element) !== null) {
      /* eslint-disable no-new */
      new Vue({
        el: '#' + application.element,
        template: '<App :application="application" :id="application.element"/>',
        components: {App},
        data: {
          application: window[application.name]
        },
        store,
        router: new VueRouter({
          mode: 'history'
        })
      })
    } else {
      console.error('Элемент для размещения приложения не найден')
    }
  })
} while (false)



// WEBPACK FOOTER //
// ./src/main.js